export enum AppsBannerEvents {
  ResurfaceBanner = `apps.cookie-banner.resurface`,
}
